export default __webpack_public_path__ + "static/media/big_sofa.08b849e8.png";